/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { PageTemplate } from '../../templates/pageTemplate';
import { ContentTemplate } from '../../templates/contentTemplate';
import AccessErrorImage from './assets/image-error-noAccess.svg';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
export var NoAccessError = function NoAccessError(props) {
  var _mixpanelProps$tracke, _mixpanelProps$tracke2;
  var onBack = props.onBack,
    appName = props.appName,
    mixpanelProps = props.mixpanelProps;
  var intl = useIntl();
  useDocumentTitle(intl.formatMessage({
    id: 'embers.pageTitle.error.noAccess',
    defaultMessage: 'No access - Promethean'
  }));
  mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).mixpanelTrackHelper) === null || _mixpanelProps$tracke === void 0 || _mixpanelProps$tracke.call(_mixpanelProps$tracke2, 'No Access');
  return /*#__PURE__*/React.createElement(PageTemplate, null, /*#__PURE__*/React.createElement(ContentTemplate, {
    type: "error",
    pageTitle: intl.formatMessage({
      id: 'embers.globalError.noAccess.title',
      defaultMessage: 'No access'
    }),
    errorMessage: intl.formatMessage({
      id: 'embers.globalError.noAccess.body',
      defaultMessage: 'Looks like you don’t currently have access to {appName}. Choose a different app from the app switcher or request access from your Organization Administrator.'
    }, {
      appName: appName
    }),
    errorImage: AccessErrorImage,
    onBack: onBack
  }));
};